import Icon from '@/components/svg/icon'
import { Tab, TabGroup, TabList } from '@headlessui/react'

import clsx from 'clsx'
import { useEffect, useState } from 'react'

interface TabbedSearchProps {
	currentFilter: string
	onFilterChange: (filter: string) => void
	zipCode: string
	onZipCodeChange: (zip: string) => void
}

const options = [
	{ label: 'Sales', value: 'Sales' },
	{ label: 'Repair', value: 'Authorized Warranty Repair Center' },
	{ label: 'Parts', value: 'Parts' },
]

export default function TabbedSearch({
	currentFilter,
	onFilterChange,
	zipCode,
	onZipCodeChange,
}: TabbedSearchProps) {
	const [localZipCode, setLocalZipCode] = useState(zipCode)

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			if (localZipCode !== zipCode) {
				onZipCodeChange(localZipCode)
			}
		}, 1000) // 1000ms delay

		return () => clearTimeout(timeoutId)
	}, [localZipCode, onZipCodeChange, zipCode])

	return (
		<div className="tabbed-search @container">
			<div className="relative max-w-screen-2xl mx-auto @3xl:-mt-24 z-10">
				<TabGroup>
					<div className="@3xl:common-x-padding">
						{/* Tab List */}
						<TabList className="flex divide-x divide-blue-light">
							{options.map((option) => (
								<Tab
									key={option.value}
									className={`tab-button ${currentFilter === option.value && 'active'}`}
									onClick={() => onFilterChange(option.value)}
									value={option.value}
								>
									{option.label}
								</Tab>
							))}
						</TabList>

						{/* Search Input and Select */}
						<div
							className={clsx(
								'flex flex-col @3xl:flex-row @3xl:items-center justify-between p-2 rounded-lg rounded-tl-none bg-white',
								currentFilter === 'Parts' && 'hidden'
							)}
						>
							<div className="flex items-center gap-2 px-3 @3xl:px-6 flex-1">
								<Icon icon="LocationPinSimple" className="w-5" />
								<input
									className="w-full py-5 outline-none"
									type="text"
									placeholder="Search by zip code"
									value={localZipCode}
									onChange={(e) => setLocalZipCode(e.target.value)}
								/>
							</div>
						</div>
					</div>
				</TabGroup>
			</div>
		</div>
	)
}
